module.exports = __webpack_public_path__ + "static/media/file_type_video_error_icon.096e368e.svg";